import { useEffect, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import ThreeDotsLoading from '../components/primitives/ThreeDotsLoading';
import { useTranslation } from '../hooks/useTranslation';

export default function RegisterSlack() {
    const t = useTranslation();
    const { url, getAuthToken } = useAuth();
    //const { disabled, setDisabled } = useState(false);

    async function handleSlackRegister() {
        try {
            //setDisabled(true);
            const token = await getAuthToken();
            if (!token)
                throw new Error("Failed to get token");
            window.location.href = `${url}/slack/install?JPChatToken=${token}`;
        } catch(error) {
            console.log("Failed to register workspace")
        }
    }

    useEffect(() => {
        handleSlackRegister();
    }, []);

    return (
        <div className="analytics-container">
            <h1>{t('Registering with {{platform}}', { platform: 'Slack' })}</h1>
            <ThreeDotsLoading />
        </div>
    )
}
